import { ReactNode, useContext } from 'react'
import { createPortal } from 'react-dom'

import { PopupController } from './Controller'
import { getRoot } from './helpers/getRoot'
import { PortalContext } from './PortalContext'

interface IPopupPortal {
  children: ReactNode
  modal?: boolean
}

export const Portal = ({ children, modal = false }: IPopupPortal) => {
  const { rootNode, containerParent, subAppClass } = useContext(PortalContext)
  const root = getRoot({ rootNode, containerParent, subAppClass })

  return createPortal(<PopupController modal={modal}>{children}</PopupController>, root)
}
